export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_WEB_API_KEY||'',
    domain: process.env.REACT_APP_FIREBASE_DYNAMIC_LINK_DOMAIN||'',
    baseUrl: process.env.REACT_APP_FIREBASE_DYNAMIC_LINK_DOMAIN_PREFIX||'',
    androidPACKAGEName: process.env.REACT_APP_FIREBASE_ANDROID_PACKAGE_NAME || '',
    iosBundleId: process.env.REACT_APP_FIREBASE_IOS_BUNDLE_ID || '',
    PORTAL_URL: process.env.REACT_APP_PORTAL_URL || '',
    DYNAMIC_LINK_PREFIX: process.env.REACT_APP_DYNAMIC_LINK_PREFIX || '',

    iOS: {
        appstoreId: "1382836741",
        bundleId: "com.WadiDeglaClub.WadiDegla",
    },
    android: {
        packageName: "com.emeint.WadiDegla",
    },

};



const firebasedynamiclinks = 'https://firebasedynamiclinks.googleapis.com/v1/shortLinks';

export const deepLinkingBaseUrl = `${firebasedynamiclinks}?key=${firebaseConfig.apiKey}`;
